import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, InviteIcon } from '@blade/ui-kit'
import { openInviteReferralDialogAction } from '@root/features/referral/atoms'
import { ReferralsTable } from '@root/features/referral/ui/desktop'
import { useAppRoutes } from '@root/features/routing'
import { useTranslation } from '@root/shared/localization'

import { Board } from '../../common'
import { BoardTitle } from '../../common/board-title'

type ReferralsBoardProps = {}

export const ReferralUsersBoard: React.FC<ReferralsBoardProps> = () => {
  const { t } = useTranslation()
  const { navigateToProfileIndex } = useAppRoutes()
  const openInviteReferralDialog = useAction(openInviteReferralDialogAction)

  return (
    <Board>
      <Header>
        <BoardTitle
          onBack={navigateToProfileIndex}
          title={t('referral.your_referrals')}
        />

        <Button
          iconLeft={<InviteIcon />}
          onClick={() => {
            openInviteReferralDialog()
          }}
          variant="solid"
          color="primary"
          size="xxs"
          radius="rounded"
        >
          {t('referral.invite_referral')}
        </Button>
      </Header>
      <ReferralsTable />
    </Board>
  )
}

const Header = styled.div`
  height: 42px;
  display: grid;
  align-items: center;
  padding-inline: 8px 16px;
  grid-template-columns: auto auto 1fr;
  gap: 16px;
`
